import React, { useContext, useEffect } from "react";
import { withRouter } from "react-router-dom";
import HorizontalNav from "../navigation/HorizontalNav";
import MLBPlayerSummary from "./mlb-player-summary/MLBPlayerSummary";
import Requests from "./Requests";
// import WBCPrimaryOutlinedButton from "../elements/WBCPrimaryOutlinedButton";
import AuthContext from "../../contexts/AuthContext";
import GlobalFedDropdownContext from "../../contexts/GlobalFedDropdownContext";
import { MLBPlayersDashboardTabSwitcher } from "./MLBPlayersDashboardStyles";
import MLBPlayerSummaryContext from "../../contexts/MLBPlayerSummaryContext";

const MLBPlayersDashboard = withRouter(() => {
  const authContext = useContext(AuthContext);
  const globalFedDropdownContext = useContext(GlobalFedDropdownContext);

  const { isBOC } = authContext.state;
  const { dispatch: globalFedDropdownDispatch } = globalFedDropdownContext;
  const { resetState } = useContext(MLBPlayerSummaryContext);

  const MLBPlayerSummaryTab = {
    name: "MLB Player Summary",
    component: MLBPlayerSummary,
    id: "summary"
  };

  const RequestsTab = {
    name: "Requests",
    component: Requests,
    id: "requests"
  };

  useEffect(() => {
    return () => {
      resetState();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Hide Global Fed Team dropdown
  useEffect(() => {
    globalFedDropdownDispatch({ type: "setShowingState", showingState: false });
  }, [globalFedDropdownDispatch]);

  return (
    <div>
      <HorizontalNav title="MLB Players">
        {/* TODO: Uncomment and implement once export functionality is built */}
        {/* <div className="my-2 mx-4">
          <WBCPrimaryOutlinedButton className="btn-md" onClick={() => console.log("export not implemented")}>
            Export
          </WBCPrimaryOutlinedButton>
        </div> */}
      </HorizontalNav>
      <div>
        <MLBPlayersDashboardTabSwitcher
          hasPadding={false}
          hideOnMobile={false}
          tabs={isBOC ? [MLBPlayerSummaryTab, RequestsTab] : [RequestsTab]}
        />
      </div>
    </div>
  );
});

export default MLBPlayersDashboard;
